import React from "react";
import styles from './FlightInfoLine.module.scss'
import LocationTime from './components/locationTime/LocationTime';
import {productLatitudeSelector, productLongitudeSelector} from 'data/redux/selectors/productSelector';
import {ITicketDetailsWithTerms} from 'gui/components/editors/flightEditor/components/ticketDetailsForm';
import PlaneLine from './components/planeLine';
import LocationDate from './components/locationDate';
import LocationFlightCompany
  from 'gui/pages/mainRouter/pages/ad/components/adFlight/components/firstStage/components/flightDetailsCard/components/flightInfoSquare/components/FlightInfoSquareLine/components/locationFlightCompany';

export interface IFlightInfoLine {
  ticketDetails: ITicketDetailsWithTerms;
  className?: string;
  flip?: boolean;
}

const flipStyle = {
  MozTransform: 'scale(-1, -1)',
  OTransform: 'scale(-1, -1)',
  WebkitTransform: 'scale(-1, -1)',
  transform: 'scale(-1, -1)',
}

const setCorrectOriginAirportTicketDetails: any = (ticketDetails: ITicketDetailsWithTerms, flip: boolean) => ({ticketDetails: {originAirport: flip ? ticketDetails.destinationAirport : ticketDetails.originAirport}});

const FlightInfoLine = ({ticketDetails, flip, className}: IFlightInfoLine) => {
  const timeOfTakeOff = flip ? ticketDetails.destinationTimeOfTakeOff : ticketDetails.originTimeOfTakeOff;
  const timeOfLanding = flip ? ticketDetails.destinationTimeOfLanding : ticketDetails.originTimeOfLanding;
  const title = flip ? "חזור" : "הלוך";
  const longtitude = productLatitudeSelector(setCorrectOriginAirportTicketDetails(ticketDetails, flip));
  const latitude = productLongitudeSelector(setCorrectOriginAirportTicketDetails(ticketDetails, flip));
  return (
    <div
      className={`${styles.flightInfoLine} ${className}`.trim()}
    >
      <LocationFlightCompany ticketDetails={ticketDetails}/>
      <h4 className={styles.flightDirectionTitle}>
        {['טיסה', title].join(' ')}
      </h4>
      <LocationTime
        ticketDetails={ticketDetails}
        fromDestination={flip}
        flip
      />
      <PlaneLine timeOfTakeOff={timeOfTakeOff} timeOfLanding={timeOfLanding}/>
      <LocationTime
        ticketDetails={ticketDetails}
        fromDestination={flip}
      />
      <div className={styles.timeDateDivider}/>
      <LocationDate
        ticketDetails={ticketDetails}
        fromDestination={flip}
      />
    </div>
  )
};

FlightInfoLine.defaultProps = {
  className: '',
};

export default FlightInfoLine;
